import type { SetupTourDefinition } from '../core/types';

export const EXTRAS_SETUP_TOUR_TARGETS = {
  sidebarExtrasLink: 'extras-sidebar-link',
  addExtraButton: 'extras-list-add-button',
  extraForm: 'extras-create-form',
  submitButton: 'extras-submit-button',
} as const;

export const extrasSetupTour: SetupTourDefinition = {
  id: 'extras_setup',
  label: 'Extras Setup',
  onboardingKey: 'extras_setup',
  sidebarTargetsByRoute: {
    '/extras': EXTRAS_SETUP_TOUR_TARGETS.sidebarExtrasLink,
  },
  steps: [
    {
      id: 'sidebar-extras',
      route: '/extras',
      target: EXTRAS_SETUP_TOUR_TARGETS.sidebarExtrasLink,
      content: 'Click Extras in the sidebar to set up optional rental add-ons.',
      advanceOnTargetClick: true,
      expandSidebarKeys: ['/pricing'],
    },
    {
      id: 'add-extra',
      route: '/extras',
      target: EXTRAS_SETUP_TOUR_TARGETS.addExtraButton,
      content: 'Click Add New Extra to create your first extra record.',
      advanceOnTargetClick: true,
    },
    {
      id: 'extra-form',
      route: '/extras/create',
      target: EXTRAS_SETUP_TOUR_TARGETS.extraForm,
      content: 'Enter the Extra Name and a Description (optional). Click Create to save the extra.',
      showRequiredFieldsOnEnter: true,
      directNextTargets: [EXTRAS_SETUP_TOUR_TARGETS.submitButton],
      next: {
        label: 'Create',
        guardTarget: EXTRAS_SETUP_TOUR_TARGETS.extraForm,
        action: { type: 'submit' },
        waitForTargetRemoval: EXTRAS_SETUP_TOUR_TARGETS.extraForm,
        completesTour: true,
      },
    },
  ],
};
